import { supabase } from './supabase'

export function findOverrideForTask(overrides, taskNumber, taskName) {
  if (taskNumber && taskName) {
    const match = overrides.find(o =>
      o.task_number?.toLowerCase() === taskNumber.toLowerCase() &&
      o.task_name.toLowerCase() === taskName.toLowerCase()
    )
    if (match) return match
  }
  if (taskNumber) {
    const match = overrides.find(o =>
      o.task_number && o.task_number.toLowerCase() === taskNumber.toLowerCase()
    )
    if (match) return match
  }
  if (taskName) {
    const match = overrides.find(o =>
      o.task_name.toLowerCase() === taskName.toLowerCase()
    )
    if (match) return match
  }
  return null
}

export async function searchTaskHistory(q, familyRegs = null) {
  if (!q || q.trim().length < 3) return []
  try {
    let query = supabase
      .from('task_history')
      .select('*')
      .or(`item_discrep.ilike.%${q.trim()}%,item_corr_action.ilike.%${q.trim()}%`)
      .neq('item_num', '')
      .order('wo_date', { ascending: false })
      .limit(500)
    if (familyRegs?.length) query = query.in('aircraft_reg', familyRegs)
    const { data } = await query
    return data ?? []
  } catch {
    return []
  }
}

export async function getFamilyRegs(registration) {
  if (!registration) return null
  try {
    const { data: ac } = await supabase
      .from('aircraft')
      .select('model_family')
      .eq('registration', registration)
      .maybeSingle()
    if (!ac?.model_family) return null
    const { data: siblings } = await supabase
      .from('aircraft')
      .select('registration')
      .eq('model_family', ac.model_family)
    return siblings?.map(s => s.registration).filter(Boolean) ?? null
  } catch {
    return null
  }
}

export function computeHistoryStats(rows) {
  function median(arr) {
    if (!arr.length) return null
    const s = [...arr].sort((a, b) => a - b)
    const m = Math.floor(s.length / 2)
    return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2
  }
  function avg(arr) {
    return arr.length ? arr.reduce((s, v) => s + v, 0) / arr.length : null
  }
  function last(field) {
    for (const r of rows) { if (r[field] != null) return Number(r[field]) }
    return null
  }
  const hourVals    = rows.map(r => r.hours_worked).filter(v => v != null).map(Number)
  const partVals    = rows.map(r => r.parts_cost).filter(v => v != null).map(Number)
  const hourHasNull = hourVals.length < rows.length
  const partHasNull = partVals.length < rows.length
  return {
    hours: { min: hourHasNull ? null : (hourVals.length ? Math.min(...hourVals) : null), median: median(hourVals), avg: avg(hourVals), max: hourVals.length ? Math.max(...hourVals) : null, last: last('hours_worked') },
    parts: { min: partHasNull ? null : (partVals.length ? Math.min(...partVals) : null), median: median(partVals), avg: avg(partVals), max: partVals.length ? Math.max(...partVals) : null, last: last('parts_cost') },
  }
}
